<template>
  <div class="banner__layout">
    <div class="banner__banner banner_post">
      <Loader v-if="loading" />
      <template v-else>
        <div class="banner__left">
          <h1 class="banner__title">
            <span>{{ post.name }}</span>
          </h1>
          <div class="banner__author">
            <strong>{{ post.author }}</strong>
            <small class="banner__tag">{{ post.region.name }}</small>
          </div>
          <p class="banner__text">{{ post.text }}</p>
          <div class="banner__bottom">
            <div class="banner__contact">
              <span>
                <strong>Связаться по:</strong>
              </span>
              <div class="banner__links">
                <AuthorPhone wrapper="banner" :phone="post.author_phone" />

                <a
                  class="banner__link"
                  target="_blank"
                  rel="noreferrer nofollow"
                  v-for="({ href, label, icon }, index) in post.contact_types"
                  :key="`${href}_${index}`"
                  :href="href"
                  :title="label"
                  :aria-label="label"
                >
                  <img :src="icon" :alt="label" />
                </a>
              </div>
            </div>
            <div class="banner__tags">
              <span class="banner__tag">
                <i18n tag="small" path="VUE.AVAILABLE_TIME">
                  <template #from>
                    <strong>{{ post.avaliable_time.from }}</strong>
                  </template>
                  <template #to>
                    <strong>{{ post.avaliable_time.to }}</strong>
                  </template>
                </i18n>
              </span>
            </div>
          </div>
        </div>
        <div class="banner__right">
          <img
            v-if="post.type.key == 1"
            src="@/assets/images/15MGKlq2K_DhuqHGMT0M9H.svg"
            :alt="post.name"
            :title="post.name"
          />
          <img
            v-if="post.type.key == 2"
            src="@/assets/images/kLnNi5XFXIzvdyOTdNyBe.svg"
            :alt="post.name"
            :title="post.name"
          />
          <img
            v-if="post.type.key == 3"
            src="@/assets/images/kLnNi5XFXIzvdyOTdNyBe.svg"
            :alt="post.name"
            :title="post.name"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AuthorPhone from "@/components/app/AuthorPhone";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PostBanner",
  data: () => ({
    loading: true
  }),
  computed: mapGetters(["currentPage", "post"]),
  methods: mapActions(["fetchCard"]),
  mounted() {
    this.fetchCard({
      API: this.$route.meta.API,
      id: this.$route.params.post
    }).then(() => (this.loading = false));
  },
  components: {
    AuthorPhone
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.banner {
  .banner_news,
  .banner_post {
    display: flex;
    justify-content: center;

    .banner {
      &__left,
      &__right {
        flex-basis: 50%;
      }

      &__left {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      &__right {
        img {
          width: 80%;
          margin: 0 auto;
        }
      }

      &__author {
        font-size: 18px;

        strong {
          margin: 0 10px 0 0;
        }
      }

      &__contact {
        margin: 0 0 30px;
      }

      &__link {
        position: relative;
        margin: 0 5px;
        cursor: pointer;
      }

      &__phone {
        position: absolute;
        top: 100%;
        padding: 5px 20px;
        background-color: $sec_bg;
        border-radius: 10px;
        box-shadow: 0 0 1px 1px rgba(#000, 0.1);

        a {
          color: $aux_c;
          font-weight: $b_fw;
        }
      }

      &__contact,
      &__links {
        display: flex;
      }

      &__tag {
        padding: 5px 15px;
        background-color: $prim_bg;
        border-radius: 10px;
      }
    }

    @media screen and (max-width: $max-md) {
      flex-direction: column;

      .banner {
        &__left {
          h1 {
            font-size: 26px;
          }
        }

        &__right {
          margin: 30px 0 0;
        }
      }
    }
  }
}
</style>
